<template>
    <div>
        <el-row class="">
            <el-col>
                <div class="table-grd">
                    <div class="header">
                        <h1>{{ $t('Manage organization contacts') }}</h1>
                        <contact-form :rowData="rowData" @popupupdate="updateRow" :dialogFormVisible="dialogFormVisible" @popupsave="getContacts" @popup="value => { this.dialogFormVisible = value }" />
                        <ul class="icon-list">
                            <li v-if="$store.getters.getConfig('has_permissions').includes('organization-users-updateOrganizationUser')">
                                <a href="javascript:void(0);" @click="handleCreate()" :title="$t('Create')"><i class="icon-add"></i></a>
                            </li>
                            <li><a href="javascript:void(0)" @click="exportFile" :title="$t('Export')"><i class="icon-excel"></i></a></li>
                            <li><a href="javascript:void(0)" @click="listView = !listView" :title="(listView)?$t('Grid view'):$t('List view')"><i :class="(listView)?'icon-grid-view':'icon-list-view'"></i></a></li>
                            <li><a href="javascript:void(0)" :title="$t('Search')" v-collapse-toggle="'toggle_first'"><i class="icon-advance-search"></i></a></li>
                        </ul>
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <v-collapse-wrapper ref="toggle_first" class="search-data">
                                    <div class="my-content" v-collapse-content>
                                        <el-form :model="filterData" ref="filterData" :inline="true">
                                            <div class="top-dev">
                                                <el-col :xs="24" :sm="8" :md="6" :lg="4" :xl="4">
                                                    <el-form-item prop="alphaColumn" class="alphaColumn">
                                                        <el-select v-model="filterData.alphaColumn" placeholder="Columns" size="medium" @change="alphaColumnChange">
                                                            <el-option v-for="(item) in alphaColumns" :label="item.label" :value="item.value" :key="item.value"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="16" :md="18" :lg="20" :xl="20">
                                                    <el-form-item prop="alpha" class="name-list">
                                                        <span v-for="a in alphabet" @click="alpha(a)" :class="{ active: filterData.alpha == a }" :key="a">{{a}}</span>
                                                    </el-form-item>
                                                </el-col>
                                            </div>
                                            <div class="bottom-dev">
                                                <el-col :xs="24" :sm="8" :md="6" :lg="5" :xl="3">
                                                    <el-form-item class="all-select">
                                                        <el-select v-model="selectedColumns" multiple placeholder="Columns" size="medium" collapse-tags>
                                                            <el-option v-for="(item) in column_name" :label="item.label" :value="item.value" :key="item.value"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="first_name">
                                                        <el-input v-model="filterData.first_name" :placeholder="$t('First Name')" size="medium" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="last_name">
                                                        <el-input v-model="filterData.last_name" :placeholder="$t('Last Name')" size="medium" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="email">
                                                        <el-input v-model="filterData.email" :placeholder="$t('Email')" size="medium" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="phone">
                                                        <el-input v-model="filterData.phone" :placeholder="$t('Phone')" size="medium" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="4" :lg="4" :xl="3">
                                                    <el-form-item prop="place">
                                                        <el-input v-model="filterData.place" :placeholder="$t('Place')" size="medium" @keyup.enter.native="handleCurrentChange"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="8" :md="5" :lg="4" :xl="3">
                                                    <el-form-item prop="status">
                                                        <el-select v-model="filterData.status" :placeholder="$t('Status')" size="medium">
                                                            <el-option v-for="(item) in statusList" :label="$t(item.label)" :key="item.value" :value="item.value"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :xs="24" :sm="10" :md="8" :lg="6" :xl="4">
                                                    <div class="el-form-item">
                                                        <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange" size="small">{{
                                                            $t('Search') }}</el-button>
                                                        <el-button type="cancel" @click="resetForm('filterData')" size="small">{{
                                                            $t('Reset') }}</el-button>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-form>
                                    </div>
                                </v-collapse-wrapper>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
                <div class="portlet">
                    <div class="data-grid-table-main">
                        <el-table :data="org_users.data" @sort-change="handleSortChange" fit highlight-current-row key='aTable' v-if="listView">
                            <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="60" fixed></el-table-column>
                            <el-table-column :label="$t('Actions')" width="100" fixed>
                                <template slot-scope="scope">
                                    <ul class="act-list">
                                        <li v-if="$store.getters.getConfig('has_permissions').includes('organization-users-updateOrganizationUser')">
                                            <a href="javascript:void(0);" @click="handleEdit(scope.row)"><i class="icon-edit"></i></a>
                                        </li>
                                        <li v-if="$store.getters.getConfig('has_permissions').includes('organization-users-destroyOrganizationUser')">
                                            <a href="javascript:void(0);" @click="handleDelete(scope.$index, scope.row)"><i class=" icon-delete"></i></a>
                                        </li>
                                    </ul>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('First Name')" sortable="custom" prop="first_name" v-if="selectedColumns.includes('first_name')" width="200">
                            </el-table-column>
                            <el-table-column :label="$t('Last Name')" sortable="custom" prop="last_name" v-if="selectedColumns.includes('last_name')" width="200">
                            </el-table-column>
                            <el-table-column :label="$t('Email')" sortable="custom" prop="email" v-if="selectedColumns.includes('email')" width="350">
                            </el-table-column>
                            <el-table-column :label="$t('Phone')" sortable="custom" prop="phone" v-if="selectedColumns.includes('phone')" width="200">
                            </el-table-column>
                            <el-table-column :label="$t('Place')" sortable="custom" prop="place" v-if="selectedColumns.includes('place')" width="200">
                            </el-table-column>
                            <el-table-column :label="$t('Status')" sortable="custom" prop="status" v-if="selectedColumns.includes('status')" width="150">
                                <template slot-scope="scope">
                                    <label :class="(scope.row.status == 'active'? 'act': 'in-act')" v-ucfirst="$t(scope.row.status)"></label>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('Created at')" sortable="custom" prop="created_at" v-if="selectedColumns.includes('created_at')" width="250">
                                <template slot-scope="scope">
                                    <span v-date-time-format="scope.row.created_at"></span>
                                </template>
                            </el-table-column>
                            <el-table-column :label="$t('Modified at')" sortable="custom" prop="updated_at" v-if="selectedColumns.includes('updated_at')" width="250">
                                <template slot-scope="scope">
                                    <span v-date-time-format="scope.row.updated_at"></span>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="10"></el-table-column>
                        </el-table>
                        <div class="my-content" v-else>
                            <div class="grid-stack-item-content flexbox-div">
                                <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8" v-for="(row,i) in org_users.data" :key="row.id">
                                    <el-card class="grid-card inactive-card">
                                        <div class="card-row">
                                            <div class="action-list">
                                                <label :class="(row.status == 'active'? 'act': 'in-act')" v-ucfirst="$t(row.status)" v-if="selectedColumns.includes('status')"></label>
                                                <ul class="act-list">
                                                    <li v-if="$store.getters.getConfig('has_permissions').includes('organizations-update')">
                                                        <a href="javascript:void(0);" @click="handleEdit(row)"><i class="icon-edit"></i></a>
                                                    </li>
                                                    <li v-if="$store.getters.getConfig('has_permissions').includes('organizations-destroy')">
                                                        <a href="javascript:void(0);" @click="handleDelete(i, row)"><i class=" icon-delete"></i></a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="left-border-list" v-if="selectedColumns.includes('first_name')">
                                                <h3>{{ $t('First Name') }}</h3>
                                                <p>{{ row.first_name }}</p>
                                            </div>
                                        </div>
                                        <div class="card-row">
                                            <div class="left-border-list" v-if="selectedColumns.includes('last_name')">
                                                <h3>{{ $t('Last Name') }}</h3>
                                                <p>{{ row.last_name }}</p>
                                            </div>
                                            <div class="left-border-list" v-if="selectedColumns.includes('email')">
                                                <h3>{{ $t('Email') }}</h3>
                                                <p>{{ row.email }}</p>
                                            </div>
                                            <div class="left-border-list" v-if="selectedColumns.includes('phone')">
                                                <h3>{{ $t('Phone') }}</h3>
                                                <p>{{ row.phone }}</p>
                                            </div>
                                            <div class="left-border-list">
                                                <h3>{{ $t('Address') }}</h3>
                                                <p>{{ row.address }}</p>
                                            </div>
                                            <div class="left-border-list">
                                                <h3>{{ $t('ZipCode') }}</h3>
                                                <p>{{ row.zipcode }}</p>
                                            </div>
                                            <div class="left-border-list" v-if="selectedColumns.includes('place')">
                                                <h3>{{ $t('Place') }}</h3>
                                                <p>{{ row.place }}</p>
                                            </div>
                                            <div class="left-border-list" v-if="selectedColumns.includes('created_at')">
                                                <h3>{{ $t('Created at') }}</h3>
                                                <p>
                                                    <span v-date-time-format="row.created_at"></span>
                                                </p>
                                            </div>
                                            <div class="left-border-list" v-if="selectedColumns.includes('updated_at')">
                                                <h3>{{ $t('Modified at') }}</h3>
                                                <p>
                                                    <span v-date-time-format="row.updated_at"></span>
                                                </p>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                            </div>
                        </div>
                        <el-pagination v-if="org_users.meta.total" background @size-change="handleSizeChange" @current-change="filterParams.page = filterData.page;getContacts()" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="org_users.meta.total">
                            <template>
                                <span>{{ $t('Showing out of records',{'0': org_users.data.length, '1':
                                    org_users.meta.total}) }}
                                </span>
                            </template>
                        </el-pagination>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import OrganizationContactForm from './ContactForm'
    export default {
        components: {
            "contact-form": OrganizationContactForm
        },
        props: {
            organization_slug: String
        },
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc",
                    organization_slug: this.organization_slug,
                    alphaColumn: null,
                    alpha: null,
                    status: null
                },
                statusList: process.env.KIPAKI_status,
                dialogFormVisible: false,
                formLabelWidth: "120px",
                org_users: {
                    meta: {},
                    data: []
                },
                rowData: {},
                clubsForm: {},
                column_name: [{
                        value: "first_name",
                        label: this.$t('First Name')
                    }, {
                        value: "last_name",
                        label: this.$t('Last Name')
                    },
                    {
                        value: "email",
                        label: this.$t('Email')
                    },
                    {
                        value: 'phone',
                        label: this.$t('Phone')
                    },
                    {
                        value: 'place',
                        label: this.$t('Place')
                    },
                    {
                        value: 'status',
                        label: this.$t('Status')
                    },
                    {
                        value: 'created_at',
                        label: this.$t('Created at')
                    },
                    {
                        value: 'updated_at',
                        label: this.$t('Modified at')
                    },
                ],
                selectedColumns: [],
                sortable: null,
                alphabet: 'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'.split(','),
                currentRow: {},
                dummyRow: {},
                downloadLoading: false,
                listView: true,
                filterParams: {}
            };
        },
        computed: {
            alphaColumns() {
                return this.column_name.filter(c => !['created_at', 'updated_at', 'phone', 'status', 'address',
                    'zipcode'
                ].includes(c.value));
            }
        },
        mounted() {
            this.filterParams = Object.assign({}, this.filterData);
            this.selectedColumns = this.column_name.map(a => a.value)
            this.getContacts();
        },
        methods: {
            getContacts() {
                request({
                    url: "organization-users",
                    method: "get",
                    params: this.filterParams
                }).then(response => {
                    this.org_users = response.data;
                    this.org_users.data = this.org_users.data.map(v => {
                        this.$set(v, 'edit', false)
                        return v
                    })
                });
            },
            alphaColumnChange(val) {
                this.filterParams.alphaColumn = val;
                if (this.filterData.alpha) {
                    this.getContacts();
                }
            },
            handleCreate() {
                this.rowData = {
                    place: null,
                    address: null,
                    zipcode: null,
                    status: 'active',
                    organization_slug: this.organization_slug
                };
                this.dialogFormVisible = true;
            },
            handleEdit(row) {
                this.rowData = row;
                this.rowData.edit = true;
                this.dialogFormVisible = true;
            },
            updateRow(row) {
                for (const v of this.org_users.data) {
                    if (v.id === row.id) {
                        const index = this.org_users.data.indexOf(v)
                        this.org_users.data.splice(index, 1, row)
                        break
                    }
                }
            },
            handleDelete(index, row) {
                this.$confirm(
                    this.$t('This will permanently delete the') + ' ' + this.$t('Club') + '. ' + this.$t(
                        'Do you want to continue?'),
                    this.$t('Warning'), {
                        confirmButtonText: this.$t('OK'),
                        cancelButtonText: this.$t('Cancel'),
                        type: "warning",
                        cancelButtonClass: "el-button--cancel",
                        confirmButtonClass: "el-button--primary"
                    }
                ).then(() => {
                    request({
                            url: "organization-users/" + row.id,
                            method: "delete",
                            data: {}
                        })
                        .then(response => {
                            this.getContacts();
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                        })
                        .catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                });
            },
            handleCurrentChange(event) {
                this.filterData.page = 1;
                this.filterParams = Object.assign({}, this.filterData);
                this.getContacts(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.filterParams.pageLength = event;
                this.getContacts();
            },
            handleSortChange(event) {
                this.filterParams.sortBy = event.prop;
                if (event.order === "ascending") this.filterParams.order = "asc";
                else if (event.order === "descending") this.filterParams.order = "desc";
                else {
                    this.filterParams.sortBy = "id";
                    this.filterParams.order = "desc";
                }
                this.getContacts();
            },
            indexMethod(index) {
                return index + this.filterData.pageLength * this.filterData.page - this.filterData.pageLength + 1
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.filterParams = Object.assign({}, this.filterData);
                this.getContacts();
            },
            alpha(a) {
                this.filterParams.alpha = a;
                this.filterData.alpha = a;
                if (this.filterData.alphaColumn)
                    this.getContacts();
            },
            exportFile() {
                this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = this.column_name.filter(a => {
                        return this.selectedColumns.includes(a.value)
                    }).map(b => b.label);
                    const data = this.formatJson(this.selectedColumns, this.org_users.data)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: this.$t('organization contacts')
                    })
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/Organizations/Contacts.vue